<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">

    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>Машины ангиллууд</h4>
        </div>
        <div class="col-auto">
   
            <div class="btn btn-success btn-sm" data-toggle="modal"
          data-target="#proModal">Ангилал нэмэх</div>

        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="categories!=null && categories.length>0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Зураг</th>
                <th>Нэр</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(category, index) in categories" v-bind:key="category.id">
                <td>{{index+1}}</td>
                <td>
                  <img
                    :src="_getImage(category)"
                    style="border: 1px solid #ddd; border-radius: 4px; padding: 5px; width: 50px;"
                  />
                </td>
                <td>{{category.name}}</td>

                <td>
                  <div class="row">
                    <button class="btn btn-danger btn-sm mx-1" @click="goMark(category)">марк</button>
                    <button class="btn btn-success btn-sm mx-1" @click="goDetail(category)">харах</button>
                    <button class="btn btn-warning btn-sm mx-1" @click="edit(category)">засах</button>
                    <router-link
                      :to="{ name: 'ImageAdd', params: { objectPath: 'cars/'+category.id, folderName: 'images_cars'}}"
                      class="btn btn-default btn-sm ml-2"
                    >Зураг оруулах</router-link>
                    <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
        </div>
      </div>
    </div>



    <!-- Modal -->
    <div
      class="modal fade"
      id="proModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="proModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="proModalLabel">ангилал нэмэx</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Нэр</label>
                <input
                  v-model.trim="pro.name"
                  class="form-control"
                  id="exampleInputEmail"
                  aria-describedby="emailHelp"
                  placeholder="Нэрээ оруулна уу"
                />
              </div>
              
              <div class="form-group">
                <label>Товчилсон нэр</label>
                <input
                  v-model.trim="pro.shortName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Товчилсон нэр"
                />
              </div>
              <div class="form-group">
                <label>Англи нэр</label>
                <input
                  v-model.trim="pro.engName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Англи нэр"
                />
              </div>
              <div class="form-group">
                <label>Дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="pro.description"
                  class="form-control"
                  placeholder="Тайлбар мэдээлэлээ оруулна уу"
                />
              </div>
              <div class="form-group">
                <label>Хайлтын түлхүүр үгс/таслалаар хуваан бичих/</label>
                <input
                  v-model.trim="pro.tag"
                  class="form-control"
                  placeholder="Түлхүүр үгс"
                />
              </div>
              
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="saveCategory"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Xадгалаx</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
const axios = require('axios').default;
export default {
  name: "CarCategories",
  data() {
    return {
      msg: "Cars",
      categories: [],
      pro:{
        name:null,
        shortName:null,
        engName:null,
        description:null,
        tag:null

      }

    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this._getObjects();
    this.set();
    // var now=new Date();
    // var startfulldate = fb.firestore.Timestamp.fromDate(now);
    // fb.db.collectionGroup("selbeg").where("expiredAt", '<=', startfulldate).get().then((docs)=>{

    //        console.log(docs);
        
    // });

    // var startfulldate = fb.firestore.Timestamp.fromDate(now);
    // fb.db.collection("pinnedAd").where("expiredAt", '<=', startfulldate).get().then((docs)=>{
    //     console.log(docs);
    // });
  },
  methods: {
    async set(){
      console.log("SET");

      // var result=await fb.db.collection("cartypes").get()
      // for(const data of result.docs){


      //   var abc=await data.ref.collection("marks").get();
      //     for(const a of abc.docs){

      //         var bc=await a.ref.collection('years').get();
      //         for(const b of bc.docs){
      //           var c=await b.ref.collection("models").get();

      //           for(const itemDoc of c.docs){
                  
      //               if(itemDoc.data().name!='' && itemDoc.data().name.includes(",")){
      //                 b.ref.update( {
      //                   "enginePowers":fb.firestore.FieldValue.arrayUnion(itemDoc.data().name.substring(0, itemDoc.data().name.indexOf(",")))
      //                 });

      //               }
                  
      //           }
      //         }

      //     }
      // }

      // var result=await fb.db.collectionGroup("selbeg").get();
      // console.log(result.size);
      // var batch=fb.db.batch();



      // var docs=await fb.db.collection("selbegtypes").get();
      // var batch=fb.db.batch();
      // for(const typeDoc of docs.docs){
      //   console.log(typeDoc.data().name);
      //   if(typeDoc.exists){

      //     // var activecountDocs=await fb.db.collectionGroup("selbeg").where("category", "==", typeDoc.ref).where("active", "==", true).get();
      //     // var countDocs=await fb.db.collectionGroup("selbeg").where("category", "==", typeDoc.ref).get();
      //     // if(countDocs!=null && !countDocs.empty)
      //     //   batch.update(
      //     //     typeDoc.ref,
      //     //     {
      //     //       "numberOfAll": countDocs.size,
      //     //       "numberOfItems": activecountDocs.size
      //     //     }
      //     //   );
      //     var typesDocs=await typeDoc.ref.collection("children").get();
      //     for(const typeDoc1 of typesDocs.docs){
      //       if(typeDoc1.exists){
      //         console.log(typeDoc1.data().name);
      //         // var countDocs3=await fb.db.collectionGroup("selbeg").where("type", "==", typeDoc1.ref).where("active", "==", true).get();
      //         // var countDocs1=await fb.db.collectionGroup("selbeg").where("type", "==", typeDoc1.ref).get();
      //         // if(countDocs1!=null && !countDocs1.empty)
      //         //   batch.update(
      //         //     typeDoc1.ref,
      //         //     {
      //         //       "numberOfAll": countDocs1.size,
      //         //       "numberOfItems": countDocs3.size
      //         //     }
      //         //   );
      //         var subTypeDocs=await typeDoc1.ref.collection("children").get();
      //         for(const subTypeDoc of subTypeDocs.docs){
      //             if(subTypeDoc.exists){
      //               var countDocs4=await fb.db.collectionGroup("selbeg").where("subtype", "==", subTypeDoc.ref).where("active", "==", true).get();
      //               var countDocs2=await fb.db.collectionGroup("selbeg").where("subtype", "==", subTypeDoc.ref).get();
      //               if(countDocs2!=null && !countDocs2.empty)
      //                 batch.update(
      //                   subTypeDoc.ref,
      //                   {
      //                     "numberOfAll": countDocs2.size,
      //                     "numberOfItems": countDocs4.size
      //                   }
      //                 );
                   
      //             }
      //           }
      //       }
      //     }
      //   }
      // }
      // await batch.commit();




      // var docs=await fb.db.collection("selbegtypes").get();
      // var batch=fb.db.batch();
      
      // var storesDocs=await fb.db.collection("stores").get();
      // var i=0;
      // console.log(storesDocs.size);
      // for(const store of storesDocs.docs){
      //   if(store.exists){
      //     console.log(store.data().name);
      //     console.log(i);
          

      //     for(const typeDoc of docs.docs){
      //       if(typeDoc.exists){
      //         var selbegItems=await store.ref.collection('selbeg').where("category", "==", typeDoc.ref).get();
      //         var selbegItems1=await store.ref.collection('selbeg').where("category", "==", typeDoc.ref).where("active", "==", true).get();
      //         // if(selbegItems && !selbegItems.empty){
      //         store.ref.collection("categorycount").doc(typeDoc.id).set(
      //           {
      //             "all": selbegItems.size? selbegItems.size:0,
      //             "count": selbegItems1.size? selbegItems1.size:0
      //           }
      //         )
      //         // }
      //       }
      //     }
      //     i++;
      //   }
      // }
     
      // await batch.commit();

      console.log("DONE");
    },
    // async set(){
    //   var docs=await fb.db.collectionGroup("selbeg").where("requestDelete", "==", true).orderBy("createdAt").get();
    //   var batch=fb.db.batch();
    //   for(const itemDoc of docs.docs){
    //     if(itemDoc.exists){
    //       batch.update(
    //         itemDoc.ref,
    //         {
    //           "active": false,
    //           "deleteAt": moment().add(14, 'days').toDate(),
    //           "expiredAt": new Date()
    //         }
    //       )
    //       // console.log(itemDoc.data());
    //       // if(itemDoc.data().category!=null){
    //       //   var category=await itemDoc.data().category.get();
    //       //   if(category.exists){
    //       //     batch.update(
    //       //       itemDoc.ref,
    //       //       {
    //       //         "shortCategory.category": category.data().name
    //       //       }
    //       //     )
    //       //   } 
    //       // }

    //     }
    //   }
    //   await batch.commit();
    //   console.log("DONE");
    // },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    _getObjects() {
      var _this = this;
      var vm = this;

      fb.db
        .collection("cartypes")
        .get().then(querySnapshot1 => {
          vm.categories = [];
          querySnapshot1.forEach(data => {
            let car = data.data();
            car.id = data.id;
            vm.categories.push(car);


          });
        });


    },
    goDetail(obj) {
      this.$router.push({
        name: "SCarsCategoryAdd",
        params: { categoryId: obj.id }
      });
    },
    goMark(obj) {
      this.$router.push({
        name: "CarMarks",
        params: { cartypeId: obj.id }
      });
    },
    edit(category) {
      this.pro = Object.assign({}, category);
      $("#proModal").modal("toggle");
    },
    saveCategory() {
      if (
        this.pro != null &&
        this.pro != null &&
        this.pro.name != ""
      ) {
        if (this.pro.id != null && this.pro.id != "") {
          fb.db
            .collection("cartypes")
            .doc(this.pro.id)
            .update({
              name: this.pro.name,
              shortName: this.pro.shortName,
              engName: this.pro.engName,
              description: this.pro.description,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
              tag: this.pro.tag!=undefined?this.pro.tag:null
            });
        } 
        else {
          this.pro.createdAt = new Date();
          this.pro.userId = this.$store.getters.currentUser.uid;
          this.pro.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          
          fb.db
            .collection("cartypes")
            .doc()
            .set(this.pro);
        }
        this.pro = {
          name: null,
          shortName: null,
          description: null,
          engName:null,
          tag:null
        };
      } else {
        alert("Ангилалын нэрээ оруулна уу");
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    }
  }
};
</script>